import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [    
    {
      path: '/',
      name: 'welcome',
      component: () => import('./views/Welcome.vue')      
    },   
    {
      path: '/selectservice',
      name: 'selectservice',
      component: () => import('./views/SelectService.vue')
    },      
    {
      path: '/contactinfo',
      name: 'contactinfo',
      component: () => import('./views/ContactInfo.vue')
    }, 
    {
      path: '/confirmappointment',
      name: 'confirmappointment',
      component: () => import('./views/ConfirmAppointment.vue')
    },   
    {
      path: '/comingsoon',
      name: 'comingsoon',
      component: () => import('./views/ComingSoon.vue')
    },
    // {
    //   path: '/appointmenttype',
    //   name: 'appointmenttype',
    //   component: () => import('./views/AppointmentType.vue')
    // },
    // {
    //   path: '/schedule',
    //   name: 'schedule',
    //   component: () => import('./views/SelectAppt.vue')
    // },
    // {
    //   path: '/changeschedule',
    //   name: 'changeschedule',
    //   component: () => import('./views/ChangeSelectAppt.vue')
    // },
    // {
    //   path: '/getinfo',
    //   name: 'getinfo',
    //   component: () => import('./views/GetInfo.vue')
    // },
    // {
    //   path: '/getmoreinfo',
    //   name: 'getmoreinfo',
    //   component: () => import('./views/GetMoreInfo.vue')
    // },
    // {
    //   path:'/feenotice',
    //   name: 'feenotice',
    //   component: () => import('./views/FeeNotice.vue')
    // },
    // {
    //   path: '/picklocation',
    //   name: 'picklocation',
    //   component: () => import('./views/PickLocation.vue')
    // },    
    // {
    //   path: '/payment',
    //   name: 'payment',
    //   component: () => import('./views/Payment.vue')
    // },
    // {
    //   path: '/verifyinfo',
    //   name: 'verifyinfo',
    //   component: () => import('./views/VerifyInfo.vue')
    // },
    // {
    //   path: '/cancel',
    //   name: 'cancel',
    //   component: () => import('./views/Cancel.vue')
    // },
    // {
    //   path: '/changeappointment',
    //   name: 'changeappointment',
    //   component: () => import('./views/ChangeAppointment.vue')
    // },
    // {
    //   path: '/verifyinfo',
    //   name: 'verifyinfo',
    //   component: () => import('./views/VerifyInfo.vue')
    // }
  ]
})
